export enum TipoEntidades {
  ctf = 1,
  frota = 2,
  posto = 3,
  macro = 8
}
